import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class IndexRoute extends Route {
  @service
  router;

  afterModel() {
    super.afterModel(...arguments);

    // Redirect to the first subject in the list, so that there's content to display.
    let params = this.paramsFor('group');
    let model = this.modelFor('group/insights/progress');
    let subjectId = model.subjects[0]?.id;
    this.router.transitionTo(
      'group.insights.progress.dots',
      params.group_id,
      subjectId,
    );
  }
}
